<template lang="pug">
  BaseForm(
    :title="title"
    :routeKey="routeKey"
    :routes="routes"
    :form="form"
    :data="item"
    :update="updateItem"
    :create="createItem"
  )
</template>

<script>
import BaseForm from '@/components/app/BaseForm'
import { mapState, mapActions } from 'vuex'
import store from '@/store'

export default {
  components: { BaseForm },
  data: (vm) => ({
    title: vm.$t('news.categories.create')
  }),
  computed: {
    ...mapState('newsCategories', ['routeKey', 'routes', 'form', 'item']),
    crumbs: (vm) => [
      { text: vm.$t('news.title'), to: { name: 'news.index' } },
      { text: vm.$t('news.categories.title'), to: { name: 'news.categories.index' } },
      { text: vm.$t('news.categories.create') }
    ]
  },
  async beforeRouteEnter (to, from, next) {
    try {
      await store.dispatch('newsCategories/clearItem')
      next()
    } catch (error) {
      next(error)
    }
  },
  methods: {
    ...mapActions('newsCategories', ['createItem', 'updateItem'])
  }
}
</script>
